module.exports = __webpack_public_path__ + "media/images/gift/gift-ex3-32a59004aa515f25c12ee7595b2c2394.png";